import { useState, useEffect } from 'react';
import { Users, Car, MapPin, Award } from 'lucide-react';

export const StatsSection = () => {
  const [counters, setCounters] = useState({ customers: 0, cars: 0, cities: 0, years: 0 });
  const targets = { customers: 500, cars: 5, cities: 15, years: 5 };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          animateCounters();
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    
    const el = document.getElementById('stats-section');
    if (el) observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const animateCounters = () => {
    const duration = 2000;
    const steps = 60;
    const stepTime = duration / steps;
    let step = 0;

    const interval = setInterval(() => {
      step++;
      const progress = step / steps;
      setCounters({
        customers: Math.floor(targets.customers * progress),
        cars: Math.floor(targets.cars * progress),
        cities: Math.floor(targets.cities * progress),
        years: Math.floor(targets.years * progress)
      });
      if (step >= steps) {
        setCounters(targets);
        clearInterval(interval);
      }
    }, stepTime);
  };

  const stats = [
    { icon: Users, value: counters.customers, suffix: '+', label: 'Happy Customers' },
    { icon: Car, value: counters.cars, suffix: '+', label: 'Premium Vehicles' },
    { icon: MapPin, value: counters.cities, suffix: '+', label: 'Cities Covered' },
    { icon: Award, value: counters.years, suffix: '+', label: 'Years Experience' }
  ];

  return (
    <section
      id="stats-section"
      className="py-16 px-6 bg-primary text-white"
      data-testid="stats-section"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="text-center" data-testid={`stat-${index}`}>
              <Icon className="w-10 h-10 mx-auto mb-3 opacity-80" />
              <p className="text-5xl font-bold mb-2" style={{ fontFamily: 'Cabinet Grotesk' }}>
                {stat.value}{stat.suffix}
              </p>
              <p className="text-sm opacity-90 uppercase tracking-wider">{stat.label}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};
